import styled, { css } from 'styled-components';
import { FontSizes } from '../typography/typography.styles';
import { VisuallyHiddenStyles } from '../visually-hidden/visually-hidden.styles';
import { CustomRadio } from './radio.styles';

interface RadioButtonLabelProps {
  $disabled?: boolean;
}

interface RadioButtonCardProps {
  $disabled?: boolean;
}

export const RadioButtonCard = styled.span<RadioButtonCardProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.2rem;
  width: 100%;
  padding: 1.2rem 1.6rem;
  border: 1px solid ${({ theme }) => theme.colors.baseColors.grey50};
  border-radius: 1.2rem;
  background-color: ${({ theme }) => theme.colors.namedColors.white};
  transition-property: border-color, box-shadow, opacity, background-color;
  transition-duration: 0.2s;

  ${({ $disabled, theme }) =>
    $disabled
      ? css`
          opacity: 0.6;
          background-color: ${theme.colors.baseColors.grey5};
        `
      : undefined}
`;

export const RadioButtonLabel = styled.label<RadioButtonLabelProps>`
  display: block;
  width: 100%;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};

  ${({ $disabled }) =>
    !$disabled &&
    css`
      &:hover ${RadioButtonCard} {
        border-color: ${({ theme }) => theme.colors.radio.colorActive};
      }

      &:hover ${CustomRadio} {
        border-color: ${({ theme }) => theme.colors.radio.colorActive};
      }
    `}
`;

export const HiddenInput = styled.input`
  ${VisuallyHiddenStyles}

  &:checked + ${RadioButtonCard} {
    border-color: ${({ theme }) => theme.colors.radio.colorActive};
  }

  &:checked + ${RadioButtonCard} ${CustomRadio} {
    border-color: ${({ theme }) => theme.colors.radio.colorActive};

    &::before {
      opacity: 1;
    }
  }

  &:focus-visible + ${RadioButtonCard} {
    box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.namedColors.focus};
  }
`;

export const RadioButtonContent = styled.span`
  display: flex;
  align-items: center;
  gap: 1.6rem;
  min-width: 0;
`;

export const RadioButtonIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  height: 4rem;

  svg {
    display: block;
  }
`;

export const RadioButtonText = styled.span`
  font-size: ${FontSizes.mediumPlus};
  font-weight: 500;
  line-height: 1.33;
  letter-spacing: 0.5px;
  color: ${({ theme }) => theme.colors.baseColors.grey150};
`;
